import { useState, useEffect } from "react";
import { getUserData } from "../Components/Guestbook/getUserData";
import GuestbookForm from "../Components/Guestbook/GuestbookForm";
import GuestbookList from "../Components/Guestbook/GuestbookList";
import { BASE_URL } from "../App";

export default function Guestbook() {
  const [messages, setMessages] = useState([]);
  const [comments, setComments] = useState({});
  const [userId, setUserId] = useState(null);
  const [nickname, setNickname] = useState("");
  const [isMember, setIsMember] = useState(false);
  const [isHuman, setIsHuman] = useState(true);
  const [messagesLoading, setMessagesLoading] = useState(true);

  useEffect(() => {
    const checkStatus = async (userId, savedToken) => {
      try {
        const data = await getUserData(userId, savedToken);
        if (data) {
          if (data.token && (!savedToken || savedToken !== data.token)) {
            saveUserToken(data.token);
          }

          if (data.member) {
            setIsMember(true);
          }
          if (!data.ihminen) {
            setIsHuman(false);
          }
        }
      } catch (error) {
        console.log("Virhe käyttäjän statuksen tarkistuksessa:", error);
      }
    };
    const savedUserId = localStorage.getItem("minebikers_userId");
    const savedUserName = localStorage.getItem("minebikers_nickname");
    const savedToken = localStorage.getItem("minebikers_token");

    if (savedUserId) {
      setUserId(savedUserId);
      setNickname(savedUserName);
    }

    if (savedUserName) {
      setNickname(savedUserName);
    }

    if (savedUserId && savedUserName) {
      checkStatus(savedUserId, savedToken);
    }
    getPosts();
  }, []);

  const saveUserId = (id) => {
    localStorage.setItem("minebikers_userId", id);
    setUserId(id);
  };

  const saveUserName = (name) => {
    localStorage.setItem("minebikers_nickname", name);
    setNickname(name);
  };

  const saveUserToken = (token) => {
    localStorage.setItem("minebikers_token", token);
  };

  const getPosts = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/vieraskirja`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 404) {
        setMessages([]);
        setMessagesLoading(false);
        return;
      }
      if (!response.ok) {
        throw new Error("Virhe viestien haussa");
      }
      const posts = await response.json();
      setMessages(posts);
      setMessagesLoading(false);
    } catch (error) {
      alert(
        "Virhe viestien haussa, koita hetken päästä uudelleen päivittämällä sivu."
      );
    }
  };
  const getComments = async (postId) => {
    try {
      const response = await fetch(
        `${BASE_URL}/vieraskirja/comments/${postId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.ok) {
        const commentData = await response.json();
        setComments((prev) => ({
          ...prev,
          [postId]: commentData,
        }));
      } else if (response.status === 404) {
        setComments((prev) => ({
          ...prev,
          [postId]: [],
        }));
      } else {
        console.error("Kommenttien haku epäonnsitui:", response.statusText);
      }
    } catch (error) {
      console.error("Virhe kommenttien haussa:", error);
    }
  };
  const getParent = async (linkitysId) => {
    try {
      const response = await fetch(
        `${BASE_URL}/vieraskirja/parent/${linkitysId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.ok) {
        const commentData = await response.json();
        if (commentData.linkitys) {
          getComments(commentData.linkitys);
        }
      }
    } catch (error) {
      console.error("Virhe kommenttien haussa:", error);
    }
  };

  return (
    <div className="guestbook">
      <GuestbookForm
        refreshPosts={() => getPosts()}
        refreshComments={getComments}
        refreshParent={getParent}
        userId={userId}
        setUserId={setUserId}
        nickname={nickname}
        setNickname={setNickname}
        saveUserId={saveUserId}
        saveUserName={saveUserName}
        saveUserToken={saveUserToken}
        savedToken={localStorage.getItem("minebikers_token")}
        isHuman={isHuman}
      />
      <GuestbookList
        nickname={nickname}
        setNickname={setNickname}
        messages={messages}
        setMessages={setMessages}
        comments={comments}
        setComments={setComments}
        userId={userId}
        setUserId={setUserId}
        refreshPosts={() => getPosts()}
        refreshComments={getComments}
        refreshParent={getParent}
        isMember={isMember}
        isHuman={isHuman}
        saveUserId={saveUserId}
        saveUserName={saveUserName}
        saveUserToken={saveUserToken}
        savedToken={localStorage.getItem("minebikers_token")}
        messagesLoading={messagesLoading}
      />
    </div>
  );
}
